import React, { useState, useEffect, useMemo } from 'react'
import lodash from 'lodash'
import styled from 'styled-components'

import Field from '../../../../../../../../1stlog-ui/src/components/Field'
import useOrderEntry from '../../../../../useOrderEntry'

const Wrapper = styled.div``

const ConfirmationDetails = (props) => {
  const {} = props

  const { isInternal } = useOrderEntry()

  return (
    <Wrapper>
      <div className="text-muted mb-1">
        {isInternal
          ? 'Die gewählte Zeitoption ist nur auf Anfrage verfügbar. Bitte klären Sie vorab ab, ob der Auftrag entsprechend ausgeführt werden kann.'
          : 'Die gewählte Zeitoption ist nur auf Anfrage verfügbar. Sobald Sie den Auftrag abgesendet haben, geben wir Ihnen umgehend bescheid, ob wir diesen durchführen können.'}
      </div>
      <Field name="phone" label={i18n.t('phone', 'Telefon')}>
        {({ value }) => <div>{value}</div>}
      </Field>
      <Field name="email" label="E-Mail">
        {({ value }) => <div>{value}</div>}
      </Field>

      <Field name="infos" label="Anmerkungen">
        {({ value }) => <div>{value}</div>}
      </Field>
    </Wrapper>
  )
}

export default ConfirmationDetails
